module.exports = __webpack_public_path__ + "assets/SquareByOppMidpointsDetailed.be59e729459c0960a742a5062cd65965.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareByOppMidpointsDetailed.png
// module id = 566
// module chunks = 0